export enum EarlyAccessEnum {
  ALL = 'ALL',
  ROLE_EDIT = 'ROLE_EDIT',
  TRANSFER_ACCOUNT = 'TRANSFER_ACCOUNT',
  RECURSIVE_PERMANENT_DELETE = 'RECURSIVE_PERMANENT_DELETE',
  ZIP_UPLOAD = 'ZIP_UPLOAD',
  STYLES = 'STYLES',
  ALTINN = 'ALTINN',
  ORGBRAIN_SUPPORT = 'ORGBRAIN_SUPPORT',
  OPENAI = 'OPENAI',
  INVESTORIMPORT = 'INVESTORIMPORT',
  REDUCED_RELOAD = 'REDUCED_RELOAD',
}

// if deprecated grant access to all users
export const deprecatedEarlyAccessMap: { [key in EarlyAccessEnum]: boolean } = {
  [EarlyAccessEnum.ALL]: false,
  [EarlyAccessEnum.ROLE_EDIT]: false,
  [EarlyAccessEnum.TRANSFER_ACCOUNT]: false,
  [EarlyAccessEnum.RECURSIVE_PERMANENT_DELETE]: false,
  [EarlyAccessEnum.ZIP_UPLOAD]: false,
  [EarlyAccessEnum.STYLES]: false,
  [EarlyAccessEnum.ALTINN]: false,
  [EarlyAccessEnum.ORGBRAIN_SUPPORT]: true,
  [EarlyAccessEnum.OPENAI]: true,
  [EarlyAccessEnum.INVESTORIMPORT]: false,
  [EarlyAccessEnum.REDUCED_RELOAD]: false,
};

export type EarlyAccessMap = { [key in EarlyAccessEnum]: boolean };
